/* eslint-disable  */
import React, { useEffect, useState, useMemo, useRef } from "react";
import { io } from "socket.io-client";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import { messageActionCreators, authActionCreators } from "../../services/Actions";
import RenderHirePurchasePage from "../RenderHirePurchasePage";
import moment from "moment";
import Loader from "../../Components/Loader";
import "./HirePurchaseMessage.css";

function HirePurchaseMessage() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [activeFilter, setActiveFilter] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  // Right-click context menu: { x, y, messageId, chatId }
  const [contextMenu, setContextMenu] = useState(null);

  const handleContextMenu = (e, message) => {
    e.preventDefault();
    const last = message?.chat?.at(-1);
    const readStatus = last?.system_user_read ?? last?.is_read ?? false;
    setContextMenu({
      x: e.clientX,
      y: e.clientY,
      messageId: message?._id,
      chatId: last?._id,
      isUnread: !readStatus,
      title: message?.userData?.name || message?.title || "Message",
    });
  };

  const handleMarkUnread = async () => {
    if (!contextMenu) return;
    const { messageId, chatId } = contextMenu;
    setContextMenu(null);
    await MarkMessageAsUnread(messageId, chatId);
    GetMessagesByDepartment("Mart Officer");
  };

  const handleMarkRead = async () => {
    if (!contextMenu) return;
    const { messageId, chatId } = contextMenu;
    setContextMenu(null);
    await MarkMessageAsRead(messageId, chatId);
    GetMessagesByDepartment("Mart Officer");
  };

  // Close the context menu on any outside click / scroll
  useEffect(() => {
    if (!contextMenu) return;
    const close = () => setContextMenu(null);
    window.addEventListener("click", close);
    window.addEventListener("scroll", close, true);
    return () => {
      window.removeEventListener("click", close);
      window.removeEventListener("scroll", close, true);
    };
  }, [contextMenu]);

  const { GetMessagesByDepartment, MarkMessageAsRead, MarkMessageAsUnread } =
    bindActionCreators(messageActionCreators, dispatch);
  const { GetUserProfile } = bindActionCreators(authActionCreators, dispatch);
  const auth = useSelector((state) => state?.auth);
  const message = useSelector((state) => state?.message);
  const { isLoading, messages, response } = message;

  console.log("messages", messages);

  // Filter and sort messages
  const filteredAndSortedMessages = useMemo(() => {
    if (!messages || messages.length === 0) return [];

    // First, sort messages by updated_at (newest first)
    const sortedMessages = [...messages].sort(
      (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
    );

    // Then filter based on activeFilter
    let filteredMessages = sortedMessages;
    if (activeFilter === "unread") {
      filteredMessages = sortedMessages.filter((message) => {
        const chatArr = message?.chat;
        const last = chatArr?.at(-1);
        // Support both old (system_user_read) and new (is_read) fields
        const isRead = last?.system_user_read ?? last?.is_read ?? false;
        return !isRead;
      });
    } else if (activeFilter === "read") {
      filteredMessages = sortedMessages.filter((message) => {
        const chatArr = message?.chat;
        const last = chatArr?.at(-1);
        const isRead = last?.system_user_read ?? last?.is_read ?? false;
        return isRead;
      });
    }

    // Apply search filter if search term exists
    if (searchTerm) {
      filteredMessages = filteredMessages.filter((message) => {
        const staffId = message?.userData?.staff_id || message?.title || "";
        return staffId.toLowerCase().includes(searchTerm.toLowerCase());
      });
    }

    return filteredMessages;
  }, [messages, activeFilter, searchTerm]);

  // Count messages for filter badges
  const messageCounts = useMemo(() => {
    if (!messages || messages.length === 0) {
      return { all: 0, unread: 0, read: 0 };
    }

    const unreadCount = messages.filter((message) => {
      const chatArr = message?.chat;
      const last = chatArr?.at(-1);
      const isRead = last?.system_user_read ?? last?.is_read ?? false;
      return !isRead;
    }).length;

    return {
      all: messages.length,
      unread: unreadCount,
      read: messages.length - unreadCount,
    };
  }, [messages]);

  useEffect(() => {
    GetUserProfile();
    GetMessagesByDepartment("Mart Officer");
  }, []);

  // Socket.IO: join department room, receive list updates incrementally
  useEffect(() => {
    // const socket = io("http://localhost:8900", {
    const socket = io("https://api.upnmg.com", {
      transports: ["websocket", "polling"],
      reconnectionAttempts: 10,
      reconnectionDelay: 2000,
    });

    const joinRoom = () => {
      socket.emit("dept:join", { department: "Mart Officer" });
    };

    socket.on("connect", joinRoom);
    socket.on("reconnect", joinRoom);

    socket.on("dept:message_new", (update) => {
      dispatch({ type: "UPDATE_MESSAGES_LIST_ITEM", payload: update });
    });

    return () => {
      socket.emit("dept:leave", { department: "Mart Officer" });
      socket.disconnect();
    };
  }, []);

  return (
    <RenderHirePurchasePage>
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 p-4">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">Messages</h1>
            <p className="text-gray-600 dark:text-gray-400">
              Manage mart department communications
            </p>
          </div>

          {/* Filter Tabs and Search */}
          <div className="mb-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div className="flex space-x-1 p-1 bg-gray-100 dark:bg-gray-800 rounded-lg w-fit">
              {[
                { key: "all", label: "All Messages", count: messageCounts.all },
                { key: "unread", label: "Unread", count: messageCounts.unread },
                { key: "read", label: "Read", count: messageCounts.read },
              ].map((filter) => (
                <button
                  key={filter.key}
                  onClick={() => setActiveFilter(filter.key)}
                  className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 flex items-center space-x-2 ${activeFilter === filter.key
                      ? "bg-white dark:bg-gray-700 text-green-600 dark:text-green-400 shadow-sm"
                      : "text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white hover:bg-gray-50 dark:hover:bg-gray-700"
                    }`}
                >
                  <span>{filter.label}</span>
                  {filter.count > 0 && (
                    <span
                      className={`inline-flex items-center justify-center px-2 py-1 text-xs font-medium rounded-full ${activeFilter === filter.key
                          ? "bg-blue-100 dark:bg-blue-900 text-green-600 dark:text-green-400"
                          : "bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-300"
                        }`}
                    >
                      {filter.count}
                    </span>
                  )}
                </button>
              ))}
            </div>

            {/* Search by Staff ID */}
            <div className="relative w-full md:w-64">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg
                  className="h-5 w-5 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <input
                type="text"
                className="block w-full pl-10 pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md leading-5 bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                placeholder="Search by Staff ID"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>

          {/* Messages Container */}
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden border border-gray-200 dark:border-gray-700">
            {/* Table Header */}
            <div className="bg-blue-700 px-4 py-4">
              <div className="grid grid-cols-12 gap-4 text-white font-semibold text-sm  ">
                <div className="col-span-3 ">Member Info</div>
                <div className="col-span-2">Reference</div>
                <div className="col-span-4">Subject</div>
                <div className="col-span-2">Department</div>
                <div className="col-span-1 ">Last Update</div>
              </div>
            </div>

            {/* Messages List */}
            <div className="divide-y divide-gray-200 dark:divide-gray-700">
              {filteredAndSortedMessages?.length > 0 ? (
                filteredAndSortedMessages?.map((message, index) => {
                  let chatArr = message?.chat;
                  let last = chatArr?.at(-1);
                  console.log("last", last);
                  const readStatus = last?.system_user_read ?? last?.is_read ?? false;
                  let isUnread = !readStatus;

                  return (
                    <div
                      key={message?._id}
                      className={`grid grid-cols-12 gap-4 px-6 py-5 cursor-pointer transition-all duration-200 hover:bg-gray-50 dark:hover:bg-gray-700/50 hover:shadow-md ${isUnread
                          ? "bg-blue-50 dark:bg-blue-900/30 border-l-4 border-l-green-500"
                          : ""
                        }`}
                      onContextMenu={(e) => handleContextMenu(e, message)}
                      onClick={() => {
                        MarkMessageAsRead(message?._id, last?._id);
                        history.push({
                          pathname: "/mart/messages-detailed",
                          state: {
                            chat_id: message?._id,
                            userData: message?.userData,
                            reference: message?.reference,
                            subject: message?.title || message?.subject,
                            department: message?.system_user,
                          },
                        });
                      }}
                    >
                      {/* Member Info */}
                      <div className="col-span-3 flex items-center space-x-3">
                        <div className="flex-shrink-0">
                          <div className="w-12 h-12 rounded-full overflow-hidden ring-2 ring-gray-200 hover:ring-blue-400 transition-all duration-200">
                            {message?.userData?.profile_image ? (
                              <img
                                className="w-full h-full object-cover"
                                src={message?.userData?.profile_image}
                                alt={message?.userData?.name}
                              />
                            ) : (
                              <img
                                className="w-full h-full object-cover"
                                src="/images/dev/avarta2.jpeg"
                                alt={message?.userData?.name || message?.title}
                              />
                            )}
                          </div>
                        </div>
                        <div className="min-w-0 flex-1">
                          <p
                            className={`text-sm font-medium truncate ${isUnread ? "text-gray-900 dark:text-white" : "text-gray-700 dark:text-gray-300"
                              }`}
                          >
                            {message?.userData?.name || message?.title || "Member"}
                          </p>
                          <p className="text-xs text-gray-500 dark:text-gray-400 font-mono">
                            {message?.userData?.staff_id}
                          </p>
                        </div>
                      </div>

                      {/* Reference */}
                      <div className="col-span-2 flex items-center">
                        <div
                          className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${isUnread
                              ? "bg-blue-100 dark:bg-blue-900/50 text-green-800 dark:text-green-300"
                              : "bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300"
                            }`}
                        >
                          #{message?.reference || message?._id?.slice(-5)}
                        </div>
                      </div>

                      {/* Subject */}
                      <div className="col-span-4 min-w-0">
                        <p
                          className={`text-sm font-medium truncate mb-1 ${isUnread ? "text-gray-900 dark:text-white" : "text-gray-600 dark:text-gray-300"
                            }`}
                        >
                          {message?.title || message?.subject}
                        </p>
                        <p className="text-xs text-gray-500 dark:text-gray-400 truncate">
                          {last?.message && last.message.length > 60
                            ? `${last.message.slice(0, 60)}...`
                            : last?.message}
                        </p>
                      </div>

                      {/* Department */}
                      <div className="col-span-2 flex items-center">
                        <div className="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-green-100 dark:bg-green-900/50 text-green-800 dark:text-green-300">
                          {message?.system_user || "Mart Officer"}
                        </div>
                      </div>

                      {/* Last Update */}
                      <div className="col-span-1 flex items-center justify-end">
                        <div className="text-right">
                          <p className="text-xs text-gray-500 dark:text-gray-400">
                            {message?.updated_at && moment(message.updated_at).isValid() ? moment(message.updated_at).format("MMM DD") : "—"}
                          </p>
                          <p className="text-xs text-gray-400 dark:text-gray-500">
                            {message?.updated_at && moment(message.updated_at).isValid() ? moment(message.updated_at).format("YYYY") : ""}
                          </p>
                        </div>
                        {isUnread && (
                          <div className="ml-2 w-2 h-2 bg-blue-500 rounded-full"></div>
                        )}
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="px-6 py-12 text-center">
                  <div className="w-16 h-16 mx-auto mb-4 bg-gray-100 dark:bg-gray-700 rounded-full flex items-center justify-center">
                    <svg
                      className="w-8 h-8 text-gray-400 dark:text-gray-500"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                      />
                    </svg>
                  </div>
                  <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-1">
                    {activeFilter === "all" && "No Messages Available"}
                    {activeFilter === "unread" && "No Unread Messages"}
                    {activeFilter === "read" && "No Read Messages"}
                    {searchTerm && "No matching messages found"}
                  </h3>
                  <p className="text-gray-500 dark:text-gray-400">
                    {activeFilter === "all" &&
                      !searchTerm &&
                      "Messages will appear here when they are received."}
                    {activeFilter === "unread" &&
                      !searchTerm &&
                      "All messages have been read."}
                    {activeFilter === "read" &&
                      !searchTerm &&
                      "No messages have been read yet."}
                    {searchTerm &&
                      "No messages match the staff ID you searched for."}
                  </p>
                </div>
              )}
            </div>
          </div>

          {/* Loading State */}
          {isLoading && <Loader />}
        </div>
      </div>

      {/* Right-click context menu */}
      {contextMenu && (
        <div
          className="fixed z-50 w-56 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-2xl ring-1 ring-black/5 overflow-hidden animate-[fadeIn_0.12s_ease-out]"
          style={{ top: contextMenu.y, left: contextMenu.x }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className="px-4 py-2.5 bg-gray-50 dark:bg-gray-900/60 border-b border-gray-100 dark:border-gray-700">
            <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-400 dark:text-gray-500">
              Message actions
            </p>
            <p className="text-sm font-medium text-gray-800 dark:text-gray-100 truncate">
              {contextMenu.title}
            </p>
          </div>

          {/* Actions */}
          <div className="py-1">
            <button
              className="w-full text-left px-4 py-2.5 text-sm flex items-center gap-3 transition-colors text-gray-700 dark:text-gray-200 hover:bg-blue-50 dark:hover:bg-blue-900/30 disabled:opacity-40 disabled:cursor-default disabled:hover:bg-transparent"
              onClick={handleMarkRead}
              disabled={!contextMenu.isUnread}
            >
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-blue-100 dark:bg-blue-900/50 text-blue-600 dark:text-blue-300">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </span>
              <span className="flex-1">Mark as read</span>
              {!contextMenu.isUnread && (
                <span className="text-[10px] font-medium text-gray-400">Current</span>
              )}
            </button>

            <button
              className="w-full text-left px-4 py-2.5 text-sm flex items-center gap-3 transition-colors text-gray-700 dark:text-gray-200 hover:bg-green-50 dark:hover:bg-green-900/30 disabled:opacity-40 disabled:cursor-default disabled:hover:bg-transparent"
              onClick={handleMarkUnread}
              disabled={contextMenu.isUnread}
            >
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-green-100 dark:bg-green-900/50 text-green-600 dark:text-green-300">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </span>
              <span className="flex-1">Mark as unread</span>
              {contextMenu.isUnread && (
                <span className="text-[10px] font-medium text-gray-400">Current</span>
              )}
            </button>
          </div>
        </div>
      )}
    </RenderHirePurchasePage>
  );
}

export default HirePurchaseMessage;
